import { Helmet } from 'react-helmet'
import { useEffect } from 'react'
import withDashboard from '../redux/connectors/dashboard'
import ProgressSpinner from '../components/ProgressSpinner'
import { useLocation } from 'react-router-dom';
import { digitalData404PageError, digitalDataLinkClick } from '../utils/adobe-analytics';
import TrackPageComplete from '../utils/TrackPageComplete';
import TrackUserData from '../utils/TrackUserData';

const Error = (props) => {
    const {
        pageClass,
        dashboardContent,
        fetchEnglishDashboardContent,
        fetchedEnglishDashboardContent,
        fetchingEnglishDashboardContent,
        fetchSpanishDashboardContent,
        fetchedSpanishDashboardContent,
        fetchingSpanishDashboardContent,
        dashboard
    } = props;
    const location = useLocation();
    
    useEffect(() => {
        digitalData404PageError("404 page", "404", "page not found", ".error-content");
    }, [location.pathname]);

    useEffect(() => {
        props.updatePageClass('dashboard')
        // console.log(props)
        if (!dashboardContent.loaded) {
            if (!(fetchedEnglishDashboardContent || fetchingEnglishDashboardContent)) {
                fetchEnglishDashboardContent()
            }
            if (!(fetchedSpanishDashboardContent || fetchingSpanishDashboardContent)) {
                fetchSpanishDashboardContent()
            }
        }
    }, []) // eslint-disable-line

    if (dashboardContent.loaded) {
        return (
            <div className={`prepaid-wrapper ${pageClass}`}>
                <TrackUserData data={dashboard} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Error - Xfinity Prepaid</title>
                    <link rel="icon" href="/favicon.ico" />
                </Helmet>

                <main>
                    <div id="main" role="main" className="main">
                        <div className='error-content'>
                            <img alt="" src="/site-assets/img/icon-fail.svg"></img>
                            <h1 className="page__title">
                                {dashboardContent?.accountInfoArea?._404?.oops}
                            </h1>
                            <p dangerouslySetInnerHTML={{__html: dashboardContent?.accountInfoArea?._404?.sorryThisResourceIsNotAvailable}} />
                            <a href={dashboardContent?.accountInfoArea?._404?.backToDashboard?.link?.url}
                                className="link-button" data-tracking={digitalDataLinkClick('back-to-dashboard', dashboardContent?.accountInfoArea?._404?.backToDashboard?.link?.url, dashboardContent?.accountInfoArea?._404?.backToDashboard?.text)}>{dashboardContent?.accountInfoArea?._404?.backToDashboard?.text}</a>
                            <br/>
                            <a href={dashboardContent?.accountInfoArea?.genericErrorScreen?.secondaryLink?.link?.url} data-tracking={digitalDataLinkClick('generic-error-secondary', dashboardContent?.accountInfoArea?.genericErrorScreen?.secondaryLink?.link?.url, dashboardContent?.accountInfoArea?.genericErrorScreen?.secondaryLink?.text)}>
                                {dashboardContent?.accountInfoArea?.genericErrorScreen?.secondaryLink?.text}</a>
                        </div>
                    </div>
                </main>
                <TrackPageComplete />
            </div>
        )
    }
    else return (
        <div id="main" className="main" role="main">
            <div className="main__width-constraint">
                <ProgressSpinner loadingText="Loading..." />
            </div>
        </div>
    )
}

export default withDashboard(Error)